import React, { useRef } from 'react';
import { useWindowSize } from '../hooks';
import * as styled from './page-view.styled';
import { ScrollButton } from './scroll-button';

const PageView: React.FC<{
    dataCy: string;
    scrollTarget: React.RefObject<HTMLDivElement>;
    falseBottom?: boolean;
    imageMobile?: boolean;
    imageVariant?: 'midnight' | 'normal';
}> = ({
    children,
    dataCy,
    scrollTarget,
    imageVariant = 'midnight',
    imageMobile = true,
    falseBottom = true,
}) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const windowSize = useWindowSize();

    const imageVisible =
        contentRef.current && windowSize.height
            ? windowSize.height > contentRef.current.getBoundingClientRect().bottom
            : true;

    return (
        <styled.Root data-cy={dataCy}>
            <styled.Background />
            <styled.ImageWrapper>
                <styled.ContentWrapper ref={contentRef}>
                    <styled.Content>{children}</styled.Content>
                    <styled.Footer>
                        {falseBottom && <ScrollButton scrollTo={scrollTarget} />}
                    </styled.Footer>
                </styled.ContentWrapper>
                <styled.HomeImage
                    displayMobile={imageVisible && imageMobile}
                    variant={imageVariant}
                />
            </styled.ImageWrapper>
        </styled.Root>
    );
};

export default PageView;
